// extracted by mini-css-extract-plugin
export default {"mindFull":"mindFull_mindFull__yQX8f","mindFullGrid":"mindFull_mindFullGrid__wF-E+","mindFullBox":"mindFull_mindFullBox__3gxW-","mindFullFlex":"mindFull_mindFullFlex__x2XFm"};